import { render, staticRenderFns } from "./AdminBusCompaniesPrices.vue?vue&type=template&id=69a11d8d&"
import script from "./AdminBusCompaniesPrices.vue?vue&type=script&lang=js&"
export * from "./AdminBusCompaniesPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports